<template>
    <svg class=" c-qd a-s-fa-Ha-pa" width="20px" height="20px" viewBox="0 0 20 20" focusable="false"
                            fill="currentColor">
        <path fill="none" d="M0 0h20v20H0V0z"></path>
        <path
            d="M10 6c.82 0 1.5-.68 1.5-1.5S10.82 3 10 3s-1.5.67-1.5 1.5S9.18 6 10 6zm0 5.5c.82 0 1.5-.68 1.5-1.5s-.68-1.5-1.5-1.5-1.5.68-1.5 1.5.68 1.5 1.5 1.5zm0 5.5c.82 0 1.5-.67 1.5-1.5 0-.82-.68-1.5-1.5-1.5s-1.5.68-1.5 1.5c0 .83.68 1.5 1.5 1.5z">
        </path>
    </svg>
</template>
<script>
export default {
    name: 'ThreeDotsSvg',
}
</script>